import { Link } from "react-router-dom";
import { Instagram, Linkedin, MessageCircle, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  const socialLinks = [
    {
      name: "Instagram",
      url: "https://www.instagram.com/pahad_organics",
      icon: Instagram,
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/company/pahadtrust",
      icon: Linkedin,
    },
    {
      name: "WhatsApp",
      url: "https://wa.me/919817403824",
      icon: MessageCircle,
    },
  ];

  return (
    <footer className="bg-[#1C221F] text-[#F9F8F6] py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img 
                src="https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/dwcan3p2_PAHADLOGO.jpeg" 
                alt="PAHAD Organics"
                className="h-12 w-12 object-contain rounded-full"
              />
              <div>
                <h3 className="text-xl font-heading font-semibold">PAHAD TRUST</h3>
                <p className="text-xs text-[#8C9A74] uppercase tracking-wider">Since 2018</p>
              </div>
            </div>
            <p className="text-sm text-[#F9F8F6]/80 leading-relaxed">
              Professional Assistance for Hill Area Development - empowering Himalayan communities through sustainable agriculture and traditional knowledge.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-heading font-medium mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {["Home", "About Us", "Our Mission", "Our Team", "Events", "Gallery", "Donate"].map((item) => (
                <li key={item}>
                  <Link
                    to={item === "Home" ? "/" : `/${item.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-sm text-[#F9F8F6]/80 hover:text-[#8C9A74] transition-colors"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-heading font-medium mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm text-[#F9F8F6]/80">
                <MapPin className="h-5 w-5 text-[#8C9A74] flex-shrink-0 mt-0.5" />
                <span>Dharamshala, Himachal Pradesh, India</span>
              </li>
              <li className="flex items-start space-x-2 text-sm text-[#F9F8F6]/80">
                <Phone className="h-5 w-5 text-[#8C9A74] flex-shrink-0 mt-0.5" />
                <span>+91 98174 03824</span>
              </li>
              <li className="flex items-start space-x-2 text-sm text-[#F9F8F6]/80">
                <Mail className="h-5 w-5 text-[#8C9A74] flex-shrink-0 mt-0.5" />
                <span>info@pahadtrust.org</span>
              </li>
            </ul>
          </div>

          {/* Social & PAHAD Organics */}
          <div>
            <h4 className="text-lg font-heading font-medium mb-4">Connect With Us</h4>
            <div className="flex space-x-4 mb-6">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`social-${social.name.toLowerCase()}`}
                  className="h-10 w-10 rounded-full bg-[#2B5C45] flex items-center justify-center hover:bg-[#214835] transition-colors"
                  aria-label={social.name}
                >
                  <social.icon className="h-5 w-5 text-white" />
                </a>
              ))}
            </div>
            <div className="mt-6">
              <p className="text-sm font-medium text-[#8C9A74] mb-2">A co-brand of</p>
              <h5 className="text-xl font-heading font-semibold text-[#C86A4C]">PAHAD Organics</h5>
              <p className="text-xs text-[#F9F8F6]/60 mt-1">Straight from the Farms</p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#F9F8F6]/10 text-center">
          <p className="text-sm text-[#F9F8F6]/60">
            © {new Date().getFullYear()} PAHAD Trust. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
